// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__14FMy","notes":"Notes_notes__CQDKD","note":"Notes_note__1qRFw","markdown":"Notes_markdown__3cP0r"};